import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { MapLayerIntersectionAttributesInput } from '../intersection/MapLayerIntersectionAttributesInput.tsx';

export interface IMapLayerIdentifyConfigInputProps {
  prefix: string;
}

/**
 * Configurazione interrogazione (Identify) per un singolo layer della mappa.
 * Riusa MapLayerIntersectionAttributesInput per la gestione attributi + alias.
 */
export function MapLayerIdentifyConfigInput(
  props: IMapLayerIdentifyConfigInputProps,
) {
  const { prefix } = props;

  return (
    <>
      <FormItem
        label="Titolo"
        name={`${prefix}identify.title`}
        help="Titolo mostrato nel pannello risultati dell'interrogazione"
      >
        <TextInput
          name={`${prefix}identify.title`}
          placeholder="Se non configurato, mostra l'etichetta del livello"
        />
      </FormItem>
      <MapLayerIntersectionAttributesInput prefix={`${prefix}identify.`} />
      <FormItem
        label="Numero massimo risultati"
        name={`${prefix}identify.maxResults`}
        help="Se specificato, limita il numero di risultati restituiti dall'interrogazione"
      >
        <NumberInput name={`${prefix}identify.maxResults`} min={1} />
      </FormItem>
      <FormItem label="" name={`${prefix}identify.backOfficeOnly`}>
        <CheckboxInput name={`${prefix}identify.backOfficeOnly`}>
          Visibile solo in Back Office
        </CheckboxInput>
      </FormItem>
    </>
  );
}
